import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { makeStyles, useMediaQuery, useTheme } from '@material-ui/core';
import { colorSet } from '@components/Provider';
import * as Dialog from '@components/Dialog';
import { ServiceTypeArray } from './serviceTypeData';
import ServiceTypeCardMobile from './components/ServiceTypeCard-mobile';
import { ServiceTypeSelectStageProps } from './types';
import RequestCommonLayout from '../Layout/RequestCommonLayout';
import PannelLayout from '../Layout/PannelLayout';
import { requestEnumToString } from '@utils/enumToString';
import useRequest from '@hooks/useRequest';
import useQueryString from '@hooks/useQueryString';
import { RequestQueryString } from '../types';
import ServiceSurveyDialog from '@routes/RequestServiceType/components/ServiceSurveyDialog';
import ServiceSurveyCompleteDialog from '@routes/RequestServiceType/components/ServiceSurveyCompleteDialog';
import { ServiceSurvey } from '@components/ServiceSurvey';

const ServiceTypeSelectStageMobile: React.FC<ServiceTypeSelectStageProps> = ({
  onInformationOpen
}) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  const [recallDialogOpen, setRecallDialogOpen] = useState<boolean>(false);
  const [surveyOpen, setSurveyOpen] = useState({
    progress: false,
    complete: false
  });
  const {
    requestState,
    onInitRfqState,
    onUpdateCompleteRfq,
    lastRequestQuery,
    hasNotEndedRequest
  } = useRequest();
  const { onAddQueryString } = useQueryString<RequestQueryString>();
  const history = useHistory();
  const { serviceTypeList } = useServiceTpyeSelectTypeStyles();

  const onSendRequest = useCallback(
    (requestInfo: RequestQueryString) => {
      onAddQueryString(requestInfo);
    },
    [onAddQueryString]
  );

  useEffect(() => {
    if (hasNotEndedRequest) {
      setRecallDialogOpen(true);
      return;
    }
    if (requestState.isComplete) {
      onUpdateCompleteRfq(false);
    }
  }, [requestState, onUpdateCompleteRfq, onInitRfqState, hasNotEndedRequest]);

  return (
    <RequestCommonLayout
      matches={matches}
      title="어떤 제조서비스가 필요하세요?"
      titleBackgroundColor="linear-gradient(270deg, #6F98FA 0%, #4776E6 100%)"
      subButtonLabel="제조 서비스별 특징 알아보기"
      onClickSubButton={onInformationOpen}
      onClickClose={() => {
        history.push('/');
      }}
    >
      <Dialog.ConfirmPresenter
        isOpen={recallDialogOpen}
        title={`이전에 진행하던 ${requestEnumToString(
          requestState.serviceType
        )} 요청이 남아있습니다.`}
        description="이전에 진행하던 요청을 불러올까요?"
        onOk={() => {
          setRecallDialogOpen(false);
          onSendRequest(lastRequestQuery);
        }}
        okText="불러오기"
        onClose={() => {
          onInitRfqState();
          setRecallDialogOpen(false);
        }}
        closeText="이전 요청 삭제"
      />
      <ServiceSurveyDialog
        open={surveyOpen.progress}
        onCompleteOpen={() =>
          setSurveyOpen({ complete: true, progress: false })
        }
        onClose={() => setSurveyOpen({ complete: false, progress: false })}
      />
      <ServiceSurveyCompleteDialog
        open={surveyOpen.complete}
        onClose={() => setSurveyOpen((prev) => ({ ...prev, complete: false }))}
      />

      <PannelLayout
        content={
          <div className={serviceTypeList}>
            {ServiceTypeArray.map((serviceType) => (
              <ServiceTypeCardMobile
                key={serviceType.id}
                id={serviceType.id}
                src={serviceType.imgMobile}
                serviceName={serviceType.serviceName}
              />
            ))}
            <ServiceSurvey>
              <ServiceSurvey.MobileCard />
            </ServiceSurvey>
          </div>
        }
      />
    </RequestCommonLayout>
  );
};

export default ServiceTypeSelectStageMobile;

const useServiceTpyeSelectTypeStyles = makeStyles((theme) => ({
  serviceTypeList: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    gap: '12px',
    '& .marginBottom': {
      display: 'none'
    },
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '20px',
      '& .marginBottom': {
        display: 'block',
        padding: 10
      }
    }
  },
  suggestionCard: {
    width: '100%',
    height: 80,
    borderRadius: '16px',
    backgroundColor: colorSet.gray100,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0px 20px',
    border: 'none',
    '& .image-box': {
      width: '64px',
      height: '64px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    '&:hover': {
      cursor: 'pointer'
    }
  }
}));
